import Swal from 'sweetalert2';

// MUI dialogs sit at z-index 1300; keep SweetAlert above them so a message is never hidden behind a form.
const raise = () => {
  const container = Swal.getContainer();
  if (container) container.style.zIndex = '2000';
};

/** Success message as a SweetAlert popup (closes itself after a moment; OK dismisses it sooner). */
export const notifySuccess = (title: string, text?: string) =>
  void Swal.fire({ icon: 'success', title, text, timer: 2200, timerProgressBar: true, confirmButtonText: 'OK', confirmButtonColor: '#6226A7', didOpen: raise });

export const notifyError = (message: string) =>
  void Swal.fire({ icon: 'error', title: 'Something went wrong', text: message, confirmButtonText: 'OK', confirmButtonColor: '#6226A7', didOpen: raise });

export async function confirmDialog(opts: { title: string; description?: string; confirmText?: string; danger?: boolean }): Promise<boolean> {
  const result = await Swal.fire({
    title: opts.title,
    text: opts.description,
    icon: opts.danger ? 'warning' : 'question',
    showCancelButton: true,
    confirmButtonText: opts.confirmText || 'Confirm',
    confirmButtonColor: opts.danger ? '#d33' : '#6226A7',
    didOpen: raise,
  });
  return result.isConfirmed;
}

export const isHtmlEmpty = (html?: string) => !html || !new DOMParser().parseFromString(html, 'text/html').body.textContent?.trim();
